import * as Common from "../../commons/common"

export class Sheet {
  grade: number = 0
  name: string = ""
  curriculum_id: number = 0
  subject_name: string = ""
  subject_code: string
  sheet_type: number

  constructor(sheet: any){
    this.grade = sheet.grade;
    this.name = sheet.name;
    this.curriculum_id = sheet.curriculum_id;
    this.subject_name = sheet.subject_name;
    this.subject_code = sheet.subject_code;
    this.sheet_type = sheet.sheet_type;
  }
}

export class RowItem {
  tdColumns: any[] = new Array<any>();

  constructor(score_rates: any[]){
    
    this.tdColumns.push(score_rates[0].part1);
    this.tdColumns.push(score_rates[0].allot);

    const totalScore = Common.sumArray(score_rates.map((x: any) => x.sum_score));
    const totalAllot = Common.sumArray(score_rates.map((x: any) => x.sum_allot));
    this.tdColumns.push(Math.round(totalScore / totalAllot  * 1000) / 10);

    score_rates.forEach((x: any) => {
      this.tdColumns.push(Math.round(x.sum_score / x.sum_allot * 1000) / 10);
    });
  }
}